import { freddyTheme, IconButton, Link, SpriteIcon } from '@coolblue-development/freddy';
import { useBreakpoints } from '@hooks/useBreakpoints';
import useTestId from '@hooks/useTestId';
import { useTranslation } from '@i18n/useTranslation';

type Props = {
  onClick: () => void;
};

export default function ExplanationIcon({ onClick }: Props) {
  const { isMobile } = useBreakpoints();
  const { t } = useTranslation('webshop.productPage');
  const testId = useTestId('insurance-explanation-link');

  return isMobile ? (
    <Link
      {...testId}
      sx={{ fontWeight: freddyTheme.typography.fontWeight.openSans.normal }}
      onClick={onClick}
      ml={100}
    >{`${t('explanationLink')}`}</Link>
  ) : (
    <IconButton
      size='xsmall'
      ml={100}
      aria-label={t('explanationLink')}
      onClick={onClick}
      {...testId}
    >
      <SpriteIcon name='info-circled' color='base' innerFill='contrast' />
    </IconButton>
  );
}
